import {
    REPOSITORY_LIST,
    REPOSITORY_DETAILS,
    REPOSITORY_CREATE,
    REPOSITORY_UPDATE,
    REPOSITORY_DELETE,
    REPOSITORY_BATCH_FILES,
    REPOSITORY_EXPLORE,
    CREATE_BATCH,
    REPOSITORY_LIST_BUCKETS,
    BATCH_LIST,
    BATCH_DETAILS,
} from '../configs/routes';
import api from './api';

export const getRepositoryList = (page = 1, limit = 10, search, type, status, sortOptions) =>
    new Promise((resolve, reject) => {
        const url = buildUrlWithQuery(REPOSITORY_LIST, { page, limit, search, status, type, sortOptions });

        api.get(url)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const getRepositoryDetails = (id, page = 1, limit = 10, search, status) =>
    new Promise((resolve, reject) => {
        const url = buildUrlWithQuery(REPOSITORY_DETAILS(id), { page, limit, search, status });

        api.get(url)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const createRepository = (repositoryData) =>
    new Promise((resolve, reject) => {
        api.post(REPOSITORY_CREATE, repositoryData)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.response?.data?.error || err.message));
    });

export const updateRepository = (id, repositoryData) =>
    new Promise((resolve, reject) => {
        api.put(REPOSITORY_UPDATE(id), repositoryData)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const deleteRepository = (id) =>
    new Promise((resolve, reject) => {
        api.delete(REPOSITORY_DELETE(id))
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const getRepositoryExplore = (id, path = '', bucket = '') =>
    new Promise((resolve, reject) => {
        api.get(REPOSITORY_EXPLORE(id, path, bucket))
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const createBatch = (data) =>
    new Promise((resolve, reject) => {
        api.post(CREATE_BATCH, data)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });

export const getBatches = (page = 1, limit = 10, repository, status, search, sortOptions) =>
    new Promise((resolve, reject) => {
        const url = buildBatchesUrlWithQuery(BATCH_LIST, { page, limit, repository, status, search, sortOptions });

        api.get(url)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const getBatchDetails = (batch_id) =>
    new Promise((resolve, reject) => {
        api.get(BATCH_DETAILS(batch_id))
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const deleteBatch = (batch_id) =>
    new Promise((resolve, reject) => {
        api.delete(BATCH_DETAILS(batch_id))
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const getRepositoryBatchFiles = (batch_id, page = 1, limit = 10, search, status, sortOptions) =>
    new Promise((resolve, reject) => {
        const url = buildUrlWithQuery(REPOSITORY_BATCH_FILES(batch_id), { page, limit, search, status, sortOptions });

        api.get(url)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const getRepositoryBuckets = (id) =>
    new Promise((resolve, reject) => {
        api.get(REPOSITORY_LIST_BUCKETS(id))
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

const buildUrlWithQuery = (baseUrl, { page, limit, search, status, type, sortOptions }) => {
    const params = new URLSearchParams({
        page: String(page),
        page_size: String(limit),
    });

    if (search) params.append('search', search);

    if (status && status !== 'all') params.append('status', status);

    if (type && type !== 'all') params.append('type', type);

    if (sortOptions) {
        params.append('sort_field', sortOptions?.field);
        params.append('sort_order', sortOptions?.sort);
    }

    return baseUrl + '?' + params.toString();
};

const buildBatchesUrlWithQuery = (baseUrl, { page, limit, repository, status, search, sortOptions }) => {
    const params = new URLSearchParams({
        page: String(page),
        page_size: String(limit),
    });

    if (repository) params.append('repository', repository);

    if (status && status !== 'all') params.append('status', status);

    if (search) params.append('search', search);

    if (sortOptions) {
        params.append(
            'sort_field',
            sortOptions?.field === 'repository_name'
                ? 'repository__name'
                : sortOptions?.field === 'repository_type'
                ? 'repository__type'
                : sortOptions?.field
        );
        params.append('sort_order', sortOptions?.sort);
    }

    return baseUrl + '?' + params.toString();
};
